import useSWR from 'swr'
import useSWRInfinite from 'swr/infinite'
import { stringify } from 'qs'

// 1 export isLoading flag
// 2 prevent revalidate on component mount with fallback data
const enhanceSWR = (useEnhancedSWR) => (...args) => {
  const [dataArg, fetcherArg, configArg] = args
  const swrConfig = Object.assign({}, configArg || {}, {
    revalidateIfStale: false,
  })
  const { data, error, ...rest } = useEnhancedSWR(
    dataArg,
    fetcherArg,
    swrConfig
  )
  const isLoading = !data && !error
  return { data, error, isLoading, ...rest }
}

export const useCustomSWR = enhanceSWR(useSWR)
export const useCustomSWRInfinite = enhanceSWR(useSWRInfinite)

// programmatically read the key string from various types of `key`
// (string, function and array)
// useStaleSWR use the result of it to determine fetch from remote
// or use cache
const getLCKeyString = (key) => {
  if (typeof key === 'function') {
    return key()
  }
  if (typeof key === 'object') {
    // array
    const [path, data] = key
    return path + (data ? '' : `?${stringify(data)}`)
  }
  return key // string
}

// Not refetching data automatically
export const useStaleSWR = (key, fetcher, options = {}) => {
  const revalidationOptions = {
    revalidateIfStale: false,
    revalidateOnFocus: false,
  }
  return useCustomSWR(key, fetcher, { ...options, ...revalidationOptions })
}
